var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"confetti"},[_c('g',{staticClass:"inner"},[_c('g',{staticClass:"scale"},[_c('circle',{staticClass:"circle",attrs:{"cx":"0","cy":"0","r":"8","stroke-width":"3","stroke-linejoin":"round","stroke-linecap":"round"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }